var map = {
	"./aircon-truck.png": 1378,
	"./aircraft.png": 1379,
	"./airstarter.png": 1380,
	"./airtug.png": 1381,
	"./ambulance.png": 1382,
	"./bed.png": 1383,
	"./bicycle.png": 1384,
	"./boom-lift.png": 1385,
	"./bowser.png": 1386,
	"./boy.png": 1387,
	"./bulldozer.png": 1388,
	"./bus.png": 1389,
	"./car.png": 1390,
	"./catering-hi-lift.png": 1391,
	"./cement-mixer.png": 1392,
	"./crane.png": 1393,
	"./defueller.png": 1394,
	"./dispenser.png": 1395,
	"./excavator.png": 1396,
	"./female.png": 1397,
	"./fire-tender.png": 1398,
	"./forklift.png": 1399,
	"./galley-cart.png": 1400,
	"./garbage-wagon.png": 1401,
	"./girl.png": 1402,
	"./helmet.png": 1403,
	"./infant.png": 1404,
	"./invalid-passenger-lift.png": 1405,
	"./joint-pallet-container-loader.png": 1406,
	"./lavatory-truck.png": 1407,
	"./lorry.png": 1408,
	"./main-deck-loader.png": 1409,
	"./maintenance-platform.png": 1410,
	"./male.png": 1411,
	"./mechanical-sweeper.png": 1412,
	"./mini-bus.png": 1413,
	"./mobile-gpu.png": 1414,
	"./motorcycle.png": 1415,
	"./others.png": 1416,
	"./passenger-step.png": 1417,
	"./pmd.png": 1418,
	"./police-car.png": 1419,
	"./prime-mover.png": 1420,
	"./recovery-truck.png": 1421,
	"./scissor-lift.png": 1422,
	"./scooter.png": 1423,
	"./scrubber.png": 1424,
	"./seatbelt.png": 1425,
	"./ship.png": 1426,
	"./skyloader.png": 1427,
	"./storage-bin.png": 1428,
	"./tanker.png": 1429,
	"./tm-compressor.png": 1430,
	"./tm-gpu.png": 1431,
	"./towed-skyloader.png": 1432,
	"./tractor.png": 1433,
	"./trailer.png": 1434,
	"./tram.png": 1435,
	"./transporter.png": 1436,
	"./van.png": 1437,
	"./water-truck.png": 1438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1377;